import React from "react";
import _ from "lodash";
import styles from "./Header.module.scss";
import serviceConfig from "../../../../config/service.json";
const SERVICE = process.env.REACT_APP_SERVICE;
const LOW_PLAN = process.env.REACT_APP_LOW_PLAN;

const Header = () => {
  if (
    serviceConfig !== undefined &&
    SERVICE !== undefined &&
    LOW_PLAN !== undefined &&
    _.get(serviceConfig, SERVICE) !== undefined &&
    _.get(_.get(serviceConfig, SERVICE), LOW_PLAN) !== undefined
  ) {
    return (
      <div
        className={styles.Header}
        style={{
          backgroundColor: _.get(_.get(serviceConfig, SERVICE), LOW_PLAN)
            .header_color,
        }}
      >
        <div className={styles.Logo}>
          {!_.get(_.get(serviceConfig, SERVICE), LOW_PLAN).header_url && (
            <img
              src={_.get(_.get(serviceConfig, SERVICE), LOW_PLAN).logo}
              alt="logo"
            />
          )}
          {_.get(_.get(serviceConfig, SERVICE), LOW_PLAN).header_url && (
            <a
              href={_.get(_.get(serviceConfig, SERVICE), LOW_PLAN).header_url}
              target="_blank"
              rel="noreferrer"
            >
              <img
                src={_.get(_.get(serviceConfig, SERVICE), LOW_PLAN).logo}
                alt="logo"
              />
            </a>
          )}
        </div>
      </div>
    );
  } else {
    return <></>;
  }
};

export default Header;
